/**
 * 用于监控计算真实活跃停留在页面的时间，单位为秒，如何定义活跃停留：页面处于激活状态，且三分钟内鼠标在页面上移动，或者页面处于激活状态，且有鼠标点击事件。
 */ import { utils, checkWin } from "@alife/cone-arms-core";
var bindEvent = utils.bindEvent;
var activeStayTime = 0;
var activeStayTimer;
var lastActiveTime;
export var init = function() {
    if (!checkWin()) {
        return function() {};
    }
    activeStayTime = 0;
    lastActiveTime = Date.now();
    if (activeStayTimer) {
        clearInterval(activeStayTimer);
    }
    var lastCalculateTime = Date.now();
    activeStayTimer = setInterval(function() {
        var currentTime = Date.now();
        var timeDiff = currentTime - lastActiveTime;
        if (timeDiff > 0 && timeDiff < 181000 && currentTime > lastCalculateTime) {
            activeStayTime += Math.ceil((currentTime - lastCalculateTime) / 1000);
        }
        lastCalculateTime = currentTime;
    }, 1000);
    var updateLastActiveTime = function() {
        lastActiveTime = Date.now();
    };
    var observeEvents = [
        "click",
        "mousemove",
        "scroll",
        "keydown"
    ];
    var unbindEvents = observeEvents.map(function(event) {
        return bindEvent(document, event, updateLastActiveTime);
    });
    return function() {
        clearInterval(activeStayTimer);
        unbindEvents.forEach(function(unbind) {
            return unbind();
        });
        activeStayTime = 0;
    };
};
export var getData = function() {
    return activeStayTime;
};
export var reset = function() {
    activeStayTime = 0;
};

 //# sourceMappingURL=observe-active-stay.js.map